import { Toast } from 'antd-mobile'
import messages from 'languages/messages'
import { intl } from 'utils'
import { login } from 'store/siteConfig'

export default function resultHandle(result, dispatch, success, error) {
  switch (result.head.code) {
    case '200':
      !result.body && (result.body = {})
      typeof success === 'function' && success(result.body)
      break
    case '401':
    case '403':
    case '409':
      dispatch(login())
      break
    default: {
      // result.head.msg && Toast.info(`${result.head.msg} [${result.head.traceCode}]`, 2)
      // typeof error === 'function' && error(result)
      const msg =
        (result.head && `${result.head.msg} [${result.head.traceCode}]`) || intl.formatMessage(messages['app.error.system'])
      if (typeof error === 'function') {
        error(result, msg)
      } else {
        Toast.info(msg)
      }
      break
    }
  }
  return Object.assign(result.body || {}, {
    isFetching: false
  })
}
